module.exports = __webpack_public_path__ + "static/img/b-1.337d0763.jpg";